import {createStyles, Theme} from "@material-ui/core";
import {secondaryColor, styleColors} from "src/main.style";

export const DayDetailsStyle = (theme: Theme) => createStyles({
  bigDialog : {
    margin: 'auto 8px',
    top: '-22px',
    width: 'calc(100% - 16px)',
    position: 'relative',
  },
  topDialog : {
    margin: 'auto 8px',
    top: '-22px',
    position: 'relative',
  },
  daysPane : {
    zIndex: 1,
    maxHeight: 'calc(100% - 35px)',
    minHeight: 'calc(100% - 35px)',
    height: 'calc(100% - 35px)',
    width: '100%',
    maxWidth: '100vw',
    overflowY: 'auto',
    overflowX: 'hidden',
    scrollSnapType: 'y',
    scrollPadding: '0px',
    border: `0.5px solid ${styleColors.greyMedium1}`,
    boxSizing: 'border-box',
    borderTottom: 0,
    borderTop: 0,
    backgroundColor: styleColors.white,
    position: 'relative',
  },
  detailsPane : {
    overflow: 'hidden',
//     overflowY: 'auto',
    position: 'sticky',
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.white,
    bottom: 0,
    left: 0,
    transition: 'transform 0.2s',
  },
  detailedDay: {
    scrollSnapAlign: 'start',
    // paddingRight: '12px',
    backgroundColor: styleColors.white
  },
  dayHeader : {
    display: 'flex',
  },
  dayTitle : {
    padding: '12px',
    flex: 1,
  },
  dayDate : {
    fontSize: '22px',
    fontWeight: 600,
  },
  dayWeekday : {
    fontSize: '14px',
    fontWeight: 400,
  },
  dayLine : {
    flex: 1,
    backgroundColor: styleColors.greyMedium1,
    marginLeft: '12px',
  },
  event : {
    display: 'flex',
    position: 'relative',
  },
  eventScheduleBands : {
    display: 'flex',
    minWidth: '12px',
  },
  eventScheduleBand : {
    minHeight: '100%',
    // minWidth: '3px',
    marginRight: '1px',
    flex: 0,
    // backgroundColor: 'brown',
  },
  startBand : {
    borderRadius: '10px 10px 0px 0px',
  },
  endBand : {
    borderRadius: '0px 0px 10px 10px',
  },
  eventScheduleData : {
    padding: '12px 0px',
    paddingLeft: '5px',
    display: 'flex',
    width:'100%',
  },
  eventLine : {
    left: '68px',
    width: 'calc(100% - 80px)',
    top: 0,
    height: '1px',
    position: 'absolute',
    backgroundColor: styleColors.greyLight2,
  },
  eventScheduleCurve : {
    position: 'absolute',
    boxSizing: 'border-box',
    minHeight: 'calc(50% + 2px)',
  },
  eventColorBand : {
    minWidth: '5px',
    minHeight: '100%',
    borderRadius: '5px',
    boxSizing: 'border-box',
    margin: '0px 0px 6px 0px',
  },
  eventData : {
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
    flex:1,
    padding: '3px 0px',
    transition: 'background-color 2s, box-shadow 2s',
    transitionDelay: 'background-color 0.5s, box-shadow 0.5s',
    zIndex: 0,
    overflow:'hidden',
  //  maxWidth: 'calc(100% - 42px)',
  //  position: 'relative',
  },
  eventDataUnseen : {
    alignItems: 'center',
    flexDirection: 'row',
    display: 'flex',
    flex:1,
    padding: '3px 0px',
    backgroundColor: styleColors.deepPurpleAlpha47,
    boxShadow: `0px 0px 15px 5px ${styleColors.deepPurpleAlpha65}`,
    transition: 'background-color 2s, box-shadow 2s',
    transitionDelay: 'background-color 0.5s, box-shadow 0.5s',
    zIndex: 0,
  //  maxWidth: 'calc(100% - 42px)',
  //  position: 'relative',
  },
  eventItemTopRow : {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  eventItemRow : {
    display: 'flex',
    flexDirection: 'row',
  },
  eventTimeBoxPlacement : {
    alignSelf: 'flex-start',
  },
  eventCheckBoxPlacement : {
    minWidth: '63px',
    width: '63px',
    alignSelf: 'center',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  eventTimeBox : {
    minWidth:'60px',
    fontSize: '14px',
    fontWeight: 500,
    marginLeft: '3px',
  },
  eventDescBox : {
    flex: 1,
    fontSize: '17px',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    overflow:'hidden',
  },
  eventSeenBy : {
    fontSize: '9px',
    fontWeight: 300,
  },
  eventDescriptionText: {
    margin: 0,
    padding: 0,
    fontSize: '12px',
    fontWeight: 300,
  },
  eventDescriptionLink : {
    display: 'block',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
  },
  dayFAB : {
    color: styleColors.white,
    width: '24px',
    cursor: 'pointer',
    height: '24px',
    fontSize: '20px',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    justifyContent: 'center',
    backgroundColor: styleColors.greyMedium1, // styleColors.brightCoral,
    display: 'flex',
    overflow: 'hidden',
    boxSizing: 'border-box',
    transition: 'all 0.2s',
    alignItems: 'center',
    borderRadius: '31px',
    margin:'10px',
  },
  packingList : {
    padding: '8px',
    paddingRight: '5px',
    marginTop: '8px',
    marginLeft: '8px',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
    // borderRadius: '4px',
    maxHeight: '1500px', 
    overflow: 'auto',
    // transition: 'all 0.6s',
  },
  packingListCollapsed : {
    maxHeight: '26px', 
    overflow: 'hidden',
    backgroundColor: styleColors.white,
    border: `0px solid ${styleColors.white}`,
    marginLeft: '56px',
    fontWeight: 300,
    marginTop: '0px',
    paddingRight: '5px',
  },
  packingListHighlight : {
    backgroundColor: styleColors.deepPurple,
    borderColor: styleColors.deepPurple,
    color: styleColors.white,
  },
  packingListHeader : {
    display:'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
  },
  packingListItem : {
    display:'flex',
  },
  packingListDesc: {
    display:'flex',
    flex: 1,
    flexDirection: 'column',
    marginLeft: '12px',
    alignSelf: 'center',
  },
  packingListItemTitle : {
    fontSize:'18px',
    fontWeight: 300,
    flexDirection: 'row',
    display: 'flex',
  },
  packingListItemDesc : {
    fontSize:'12px',
  },
  packingListCheckboxContainer : {
    display: 'flex',
    alignItems: 'center',
    padding:'12px',
  },
  scheduleEventTime : {
    display: 'flex',
    alignSelf: 'flex-start',
    paddingTop: '3px',
  },
  roundCheckbox: {
    width: '20px',
    height: '20px',
    borderRadius: '20px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white,
    backgroundColor: styleColors.greyMedium1,
    position: 'relative',
    WebkitUserSelect: 'none',
  },
  roundCheckboxChecked: {
    backgroundColor: theme.palette.secondary.main,
  },
  roundCheckboxInput: {
    position: 'absolute',
    appearance: 'none',
    zIndex: -1,
  },
  adjustPackingListButton : {
    border: `1px solid ${styleColors.blackAlpha23}`,
    borderRadius: '99px',
  },
  packingListBadge : {
    backgroundColor: secondaryColor,
    minWidth: '22px',
    minHeight: '22px',
    maxHeight: '22px',
    fontSize: '16px',
    lineHeight: '18px',
    textAlign: 'center',
    borderRadius: '18px',
    pointerEvents:'none',
    transition:'all 0.3s',
    color:styleColors.white,
    alignContent: 'center',
  },
  packingListCheckmark : {
    marginLeft: '-22px',
    minWidth: '22px',
    maxWidth: '22px',
  }
});




// WEBPACK FOOTER //
// ./src/components/calendar2/dayDetails/DayDetails.style.ts